import React from "react";
import { useNavigate } from "react-router-dom";
import { Check } from "lucide-react";
import { SectionHeading } from "@/components/home/SectionHeading";

const POINTS = [
  "Easy twist-up stick",
  "No messy hands",
  "Helps moisturise dry skin",
  "Gentle enough for sensitive skin",
  "Ideal for daily comfort",
  "Perfect before applying protective patches",
];

export const BalmSection = () => {
  const navigate = useNavigate();
  return (
    <section id="balm-section" className="bg-[#F8F5EF] py-16 md:py-24" data-testid="balm-section">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <SectionHeading
          overline="The Calm Balm Stick"
          title="Meet The Calm Balm Stick"
          subtitle="A soft, mess-free balm designed to help comfort dry, sensitive and eczema-prone skin wherever your little one needs extra care."
        />
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center">
          <div className="rounded-3xl overflow-hidden aspect-square bg-gradient-to-b from-[#F8F5EF] to-[#E9E2D6]/60 shadow-[0_8px_40px_rgba(111,80,58,0.08)] flex items-center justify-center p-8">
            <img
              src="/assets/balm.png"
              alt="Baby Hemp Calm Balm Stick"
              loading="lazy"
              className="w-full h-full object-contain drop-shadow-[0_20px_30px_rgba(111,80,58,0.12)]"
            />
          </div>
          <div>
            <ul className="grid grid-cols-1 sm:grid-cols-2 gap-x-8 gap-y-4">
              {POINTS.map((p) => (
                <li key={p} className="flex items-start gap-3 text-[#6F503A]/85">
                  <span className="mt-0.5 w-5 h-5 rounded-full bg-[#B8C4A3]/30 flex items-center justify-center flex-shrink-0">
                    <Check className="w-3 h-3 text-[#6F503A]" />
                  </span>
                  {p}
                </li>
              ))}
            </ul>
            <button
              data-testid="balm-section-cta"
              onClick={() => navigate("/product/balm")}
              className="mt-9 px-7 py-4 rounded-full bg-[#6F503A] text-[#F8F5EF] font-medium hover:bg-[#5b4130] transition-colors"
            >
              Shop Calm Balm
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};
